import {
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  GhostButton,
  Modal,
  PrimaryButton,
  Space,
  Text,
} from "@certn/cascadia";
import { useTranslation } from "react-i18next";

type EmploymentVerificationUnableToVerifyModalProps = {
  onSkipClick: () => void;
  onRetryClick: () => void;
  isSkipping?: boolean;
};

export function EmploymentVerificationUnableToVerifyModal({
  onSkipClick,
  onRetryClick,
  isSkipping = false,
}: EmploymentVerificationUnableToVerifyModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen testID="konfir-unable-to-verify-modal">
      <Dialog aria-label="konfir-unable-to-verify-dialog">
        <DialogHeader>{t("Unable to verify")}</DialogHeader>
        <DialogContent>
          <Text style="global/body-primary">
            {t(
              "We couldn't verify your employment successfully with Konfir. Please try again or skip this step to upload supporting documents instead."
            )}
          </Text>
        </DialogContent>
        <DialogFooter>
          <ButtonGroup>
            <GhostButton
              testID="konfir-unable-to-verify-skip"
              onPress={onSkipClick}
              isDisabled={isSkipping}
              isLoading={isSkipping}
            >
              {t("Skip")}
            </GhostButton>
            <Space />
            <PrimaryButton
              testID="konfir-unable-to-verify-retry"
              onPress={onRetryClick}
              isDisabled={isSkipping}
            >
              {t("Retry verification")}
            </PrimaryButton>
          </ButtonGroup>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
